import { twMerge } from "tailwind-merge";
import vector3 from "../assets/vector3.svg";
const HorizontalDividerVector = ({ width = "w-[174px]" }) => {
  return (
    <div className="flex justify-center items-center py-[12px]">
      <img
        src={vector3}
        alt="vector"
        className={twMerge(
          `h-2 stroke-[1px] stroke-[rgba(226,_232,_240,_0.00)]`,
          `${width}`
        )}
      />
    </div>
  );
};

export default HorizontalDividerVector;
